import React, { SyntheticEvent } from 'react';

import styles from './IconButton.module.scss';

export interface IconButtonProps {
	id?: string;
	color: 'blue' | 'grey';
	shade?: 'light';
	size: 'xsmall' | 'small' | 'medium' | 'large';
	icon: React.ReactElement;
	'aria-label': string;
	disabled?: boolean;
	transparent?: boolean;
	onClick: (e: SyntheticEvent) => void;
	type?: 'submit';
	className?: string;
}

export const AsaphIconButton = ({
	color,
	icon,
	size,
	shade,
	transparent = false,
	disabled = false,
	'aria-label': ariaLabel,
	onClick,
	type,
	className,
	id,
}: IconButtonProps) => {
	let rootClass: any = [];
	let backgroundClass;
	switch (color) {
		case 'blue':
			backgroundClass = styles['icon-btn__background--blue'];
			rootClass.push(styles['icon-btn--blue']);
			break;
		case 'grey':
			if (shade === 'light') {
				backgroundClass =
					styles['icon-btn__background--grey-light'];
				rootClass.push(styles['icon-btn--grey-light']);
				break;
			}
			backgroundClass = styles['icon-btn__background--grey'];
			rootClass.push(styles['icon-btn--grey']);
			break;
		default:
			throw new Error(`Unknown color: ${color}`);
	}

	switch (size) {
		case 'xsmall':
			rootClass.push(styles['icon-btn--xsmall']);
			break;
		case 'small':
			rootClass.push(styles['icon-btn--small']);
			break;
		case 'medium':
			rootClass.push(styles['icon-btn--medium']);
			break;
		case 'large':
			rootClass.push(styles['icon-btn--large']);
			break;
		default:
			throw new Error(`Unknown size: ${size}`);
	}

	if (transparent) {
		backgroundClass = styles['icon-btn__background--transparent'];
	}

	const rootClasses = [
		...rootClass,
		backgroundClass,
		disabled ? styles['icon-btn--disabled'] : undefined,
		className,
	]
		.filter(Boolean)
		.join(' ');

	return (
		<button
			type={type || 'button'}
			disabled={disabled}
			aria-label={ariaLabel}
			onClick={onClick}
			id={id}
			className={rootClasses}
		>
			<span className={styles['icon-btn__label']}>{icon}</span>
		</button>
	);
};

export default AsaphIconButton;
